"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputTextArea = require("./InputTextArea");

var _InputTextArea2 = _interopRequireDefault(_InputTextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputTextArea2.default;